import { useTranslation } from 'react-i18next';
// assets
import { colors } from 'components/styles/variables';

function PhotoCredits() {
  const { t } = useTranslation();

  return (
    <div className="photo-credits">
      <div className="container">
        <span>{t('home.credits')}</span>
      </div>
      <style jsx>{`
        .photo-credits {
          font-size: 16px;
          padding: 20px 0;
          color: ${colors.G4};
        }
      `}</style>
    </div>
  );
}

export default PhotoCredits;
